export default __webpack_public_path__ + "static/media/Transparent Cropped phone.fb6ddaf4.png";